import React from 'react';

import { Helpers } from '../../core/src/helpers';
import TextOverFlowToolTip from '../../shared/components/text-overflow-tooltip';
import ConditionalWrapper from '../../shared/components/conditional-wrapper';
import Link from '../../shared/components/hyperlink';

import '../css/product-violator.less';

const ViolatorMessage = ({product, clamp, charMaxLength, className}) => {
    const violatorMarkup = Helpers.createMarkup((product.metadata && product.metadata.violator) || product.violatorMsg);
    

    return(
        <ConditionalWrapper
            condition={product.metadata && product.metadata.violatorLink}
            wrapper={children => <Link newTab={true} to={product.metadata.violatorLink}>{children}</Link>} >
            <TextOverFlowToolTip className={`violator-container${className ? ' '+className : ''}`} markup={ violatorMarkup } clamp={ clamp } charMaxLength={ charMaxLength }/>
        </ConditionalWrapper>
    );
}

export default ViolatorMessage;
